import { render, staticRenderFns } from "./EditNosologiaPage.vue?vue&type=template&id=6d49d517&"
import script from "./EditNosologiaPage.vue?vue&type=script&lang=js&"
export * from "./EditNosologiaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports